import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {EntityContainerModel} from '../../../../../../models/aggregates/erp/entity';
import {ApiVisa, BaseApiTemplateService, BasicApiResponseModel, Pagination, PagingResponseModel} from '../../shared';
import {Core2Config} from '../../shared';
import {Observable} from "rxjs";
import {CouponSerialNumberContainerModel} from "../../../../../../models/aggregates/erp/coupon";

@Injectable({providedIn: 'root'})
export class EntityAppletLoginEpService extends BaseApiTemplateService<EntityContainerModel> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX  +  Core2Config.ERP_PREFIX + 'entity';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'entity';
    this.httpClient = http;
  }

  getAllEntityForAppletLoginEp(
    appletGuid: string,
    visa: ApiVisa
  ): Observable<BasicApiResponseModel<EntityContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.get<BasicApiResponseModel<EntityContainerModel>>(
      this.apiUrl + '/basic-info/applet-login-ep/' + appletGuid,
      this.getHttpHeader(visa)
    );
  }

  public getEntityByCriteriaForAppletLoginEp(
    appletGuid: string,
    dtoObject: any,
    pagination: Pagination,
    visa: ApiVisa,
    criteria?: any,
  ): Observable<PagingResponseModel<EntityContainerModel>> {
    // console.log('get by criteria bsae-api');
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const UrlByCriteria =
      this.apiUrl + '/basic-info/applet-login-ep/' + appletGuid + '/query?' + pagination.getQueryKeyValues();
    return this.httpClient.post<PagingResponseModel<EntityContainerModel>>(
      UrlByCriteria,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  public getEntityByGuidForAppletLoginEp(
    appletGuid: string,
    guid: string,
    visa: ApiVisa
  ): Observable<BasicApiResponseModel<EntityContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.get<BasicApiResponseModel<EntityContainerModel>>(
      this.apiUrl + '/basic-info/applet-login-ep/' + appletGuid + '/' + guid,
      this.getHttpHeader(visa)
    );
  }
  
}
